import React from 'react';
import ReactDOM from 'react-dom';
import reportWebVitals from './reportWebVitals';
import 'interceptor/index';
import LoadableApp from "./LoadableApp";

// Suppress ResizeObserver loop limit exceeded error globally
// This must be at the very top to catch errors from early-loading components.
(function() {
    const suppressMessages = [
        'ResizeObserver loop completed with undelivered notifications',
        'ResizeObserver loop limit exceeded'
    ];

    const originalError = console.error;
    console.error = (...args) => {
        if (suppressMessages.some(msg => args[0]?.includes?.(msg))) {
            return;
        }
        originalError.apply(console, args);
    };

    const handler = (e) => {
        if (suppressMessages.some(msg => (e.message || '').includes(msg))) {
            e.stopImmediatePropagation();
            const overlay = document.getElementById('webpack-dev-server-client-overlay');
            if (overlay) overlay.style.display = 'none';
        }
    };

    window.addEventListener('error', handler);
    window.addEventListener('unhandledrejection', handler);
})();


const rootId = document.getElementById("root");

ReactDOM.render(
    <React.StrictMode>
        <LoadableApp />
    </React.StrictMode>,
    rootId
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

if (module.hot && process.env.NODE_ENV === "production") {
    module.hot.accept("./App", () => {
        const NextApp = require("./LoadableApp").default;
        ReactDOM.render(
            <React.StrictMode>
                <LoadableApp />
            </React.StrictMode>,
            rootId
        );
    });
}
